function News() {
  return (
    <div>
      <h1>News & Aktionen</h1>
    </div>
  );
}

export default News;
